<template>
  <div class="container-fluid">
    <div class="card card-box mb-5 my-3">
      <div class="card-header bg-card-header text-white">
        <h5 class="my-3">
          Danh sách E Voucher
        </h5>
      </div>
      <div class="card-body py-0">
        <!-- Main table element -->
        <div class="row">
          <div
            v-for="eVoucher in voucherList"
            :key="eVoucher.id"
            class="col-md-6 col-sm-6 col-lg-3 mt-4"
            @click="onSelectedVoucher(eVoucher)"
          >
            <transition name="flip">
              <div
                style="box-shadow: rgb(102 187 106 / 31%) 3px 6px; cursor: pointer; height: 200px; border: 1px solid #66bb6a; height: auto;"
                v-if="!eVoucher.selected"
              >
                <div
                  class="mt-2"
                  style="background-color: #66bb6a; color: #fff; display: inline-block; position: relative;"
                >
                  <div style="padding: 5px; padding-left: 10px;">
                    Giảm {{ convertToMoney(eVoucher.value) }} VNĐ
                    <div class="arrow-right" />
                  </div>
                </div>
                <div style="clear: both;"></div>
                <div
                  style="background-color: rgb(24, 26, 27); color: #fff; display: inline-block; position: relative;"
                >
                  <div class="px-4 small" style="padding: 3px;">
                    {{ eVoucher.serial }}
                  </div>
                </div>
                <div class="small mb-2 mt-2 mx-2">
                  {{ "Trạng thái" }}:
                  <span
                    class="font-weight-normal p-1 bg-success text-white"
                    style="border-radius: 5px;"
                    >{{ $t(getVoucherStatusType(eVoucher.status)) }}</span
                  >
                </div>
                <div class="text-center py-4 mb-4">
                  <qrcode-vue
                    :value="eVoucher.serial"
                    :size="qrCode.size"
                    level="H"
                  ></qrcode-vue>
                </div>
                <div
                  style="position: absolute; bottom: 0; left: 50%; transform: translate(-50%, -0%);"
                  v-if="eVoucher.status == VoucherStatusType.ASSIGNED"
                >
                  <div style="display: flex;">
                    <b-button
                      size="sm"
                      class="m-2"
                      variant="outline-success"
                      @click="onAssignEVoucher($event, eVoucher)"
                      >Chuyển</b-button
                    >
                  </div>
                </div>
              </div>
            </transition>
            <transition name="flip">
              <div
                v-if="eVoucher.selected"
                style="padding: 10px; box-shadow: rgb(102 187 106 / 31%) 3px 6px; cursor: pointer; height: 283.8px; border: 1px solid #66bb6a;"
              >
                <div
                  style="background-color: red; color: #fff; position: relative; display: flex; align-items: center; border-radius: 5px;"
                  class="px-2"
                >
                  <div class="mr-1 small">
                    {{ "Hết hạn sau" }}
                  </div>
                  <div class="small" style="display: flex; font-weight: bold;">
                    <!-- Days -->
                    <div class="mr-1">
                      <span>{{ countDown.days }} {{ "Ngày" }} </span>
                    </div>
                    <!-- Hours -->
                    <div class="mr-1">
                      <span>{{ countDown.hours }} {{ "Giờ" }} </span>
                    </div>
                    <!-- Minutes -->
                    <div class="mr-1">
                      <span>{{ countDown.minutes }} {{ "Phút" }} </span>
                    </div>
                    <!-- Seconds -->
                    <div>
                      <span>{{ countDown.seconds }} {{ "Giây" }}</span>
                    </div>
                  </div>
                </div>
                <div class="my-2 small">
                  Áp dụng cho các khách hàng sử dụng từ
                  {{ eVoucher.startDate }} đến {{ eVoucher.endDate }}
                </div>
                <div class="my-2 small font-italic">
                  <span style="color: red;" class="font-weight-bold ml-1"
                    >*</span
                  >
                  {{ "Mô tả" }}: {{ eVoucher.description }}
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="mt-3">
          <b-pagination
            @change="onChangePage"
            v-model="paginator.currentPage"
            :total-rows="paginator.totalPage"
            :per-page="paginator.pageSize"
            align="center"
          ></b-pagination>
        </div>
      </div>
    </div>
    <eVoucherAssignConfirmModal ref="eVoucherAssignConfirmModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VoucherStatusType from "Enum/voucherStatusType";
import EntityType from "Enum/entityType";
import functionUtils from "Utils/functionUtils";
import dateUtils from "Utils/dateUtils";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import EVoucherAssignConfirmModal from 'Components/EVoucherAssignConfirmModal'
import VoucherTransactionType from 'Enum/voucherTransactionType'
export default {
  components: {
    QrcodeVue,
    EVoucherAssignConfirmModal
  },
  data: () => ({
    voucherList: [],
    bordered: true,
    paginator: {
      currentPage: 1,
      totalPage: 1,
      pageSize: 1,
    },
    countDown: {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    runInterval: null,
    qrCode: {
      size: 100,
    },
    isAssignEVoucher: false,
    VoucherStatusType: VoucherStatusType
  }),
  computed: {
    ...mapGetters(["E_VOUCHER_DATA"]),
  },
  watch: {
    E_VOUCHER_DATA() {
      let res = this.E_VOUCHER_DATA
      // Handle paginate
      this.paginator.currentPage = res.paginate.currentPage;
      this.paginator.totalPage = res.paginate.totalPage;
      this.paginator.rowPerPage = res.paginate.perPage / 2;
      // Handle response data
      let voucherData = res.results;
      this.voucherList = [];
      for (let i = 0, size = voucherData.length; i < size; i++) {
        let voucherObj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          id: voucherData[i].id,
          serial: voucherData[i].serial,
          status: voucherData[i].status,
          startDate: this.getStartDateEVoucher(voucherData[i].workpiece),
          endDate: this.getEndDateEVoucher(voucherData[i].workpiece),
          value: voucherData[i].workpiece ? voucherData[i].workpiece.value : 0,
          description: voucherData[i].workpiece.description,
          selected: false,
        };
        this.voucherList.push(voucherObj);
      }
    },
  },
  created() {
    this.getEVoucherList();
  },
  beforeDestroy() {
    clearInterval(this.runInterval);
  },
  methods: {
    /**
     * Assign e voucher
     */
    onAssignEVoucher: function(event, eVoucher) {
      event.preventDefault();
      this.isAssignEVoucher = true;
      setTimeout(() => {
        this.isAssignEVoucher = false;
      }, 100);
      this.$swal.fire({
        title: 'Xác nhận chuyển E Voucher?',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        inputPlaceholder: 'Email',
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#66bb6a",
        confirmButtonText: 'Đồng ý',
        cancelButtonColor: "#d33",
        cancelButtonText: "Huỷ",
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          if (email == null || email == undefined || email == "") {
            this.$swal.showValidationMessage('Vui lòng nhập email!')
            return
          }
          let filter = {
            type: VoucherTransactionType.SINGLE,
            voucherId: eVoucher.id,
            email: email,
          };
          return this.TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER(filter).then(
            function(res) {
              this.$swal.fire(
                "Đã xác nhận!",
                "E Voucher của bạn đã được chuyển thành công.",
                "success"
              );
              this.getEVoucherList();
              return res
            }.bind(this)
          ).catch(
            function () {
              this.$swal.showValidationMessage('Có lỗi xảy ra!')
            }.bind(this)
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.getEVoucherList();
        }
      })
    },
    /**
     * E Voucher selected
     */
    onSelectedVoucher: function(eVoucher) {
      if (!this.isAssignEVoucher) {
        for (let i = 0, size = this.voucherList.length; i < size; i++) {
          if (this.voucherList[i].id != eVoucher.id) {
            this.voucherList[i].selected = false;
          }
        }
        clearInterval(this.runInterval);
        eVoucher.selected = !eVoucher.selected;
        if (eVoucher.selected) {
          this.countDownExpiredDate(eVoucher.endDate);
        } else {
          clearInterval(this.runInterval);
        }
      }
    },
    /**
     * Diff date
     */
    countDownExpiredDate: function(endDate) {
      endDate = dateUtils.formatDate(
        endDate,
        dateUtils.STATIC_FORMAT_DATE,
        dateUtils.STATIC_FORMAT_DATE_SQL
      );
      var end = moment(endDate); // another date
      var vm = this;
      this.runInterval = setInterval(function() {
        var now = moment(new Date()); // todays date
        var duration = moment.duration(end.diff(now));
        var miliseconds = duration.asMilliseconds();
        // Time calculations for days, hours, minutes and seconds
        vm.countDown.days = Math.floor(miliseconds / (1000 * 60 * 60 * 24));
        vm.countDown.hours = Math.floor(
          (miliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        vm.countDown.minutes = Math.floor(
          (miliseconds % (1000 * 60 * 60)) / (1000 * 60)
        );
        vm.countDown.seconds = Math.floor((miliseconds % (1000 * 60)) / 1000);
        // If the count down is over, write some text
        if (miliseconds < 0) {
          clearInterval(vm.runInterval);
          vm.isExpired = true;
        }
      }, 1000);
    },
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    /**
     * Get start date e voucher
     */
    getStartDateEVoucher: function(workpiece) {
      let startDate = workpiece ? workpiece.start_date : null;
      if (!functionUtils.isNull(startDate)) {
        return dateUtils.formatDate(
          startDate,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },
    /**
     * Get end date e voucher
     */
    getEndDateEVoucher: function(workpiece) {
      let endDate = workpiece ? workpiece.end_date : null;
      if (!functionUtils.isNull(endDate)) {
        return dateUtils.formatDate(
          endDate,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },
    /**
     * Get e voucher status type
     */
    getVoucherStatusType: function(status) {
      return functionUtils.getVoucherStatusText(status)
    },
    /**
     * Page change
     */
    onChangePage: function(page) {
      this.paginator.currentPage = page;
      this.getEVoucherList();
    },
    /**
     * Get issue e voucher queue list
     */
    getEVoucherList: function() {
      let filter = {
        params: {
          page: this.paginator.currentPage,
          type: EntityType.CUSTOMER,
        },
      };
      this.GET_E_VOUCHER_LIST(filter);
    },
    ...mapActions([
      "GET_E_VOUCHER_LIST",
      "TRANSACTION_FROM_CUSTOMER_TO_CUSTOMER",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.arrow-right {
  width: 0;
  height: 0;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 20px solid #66bb6a;
  position: absolute;
  top: 0;
  right: -20px;
}
.flip-enter-active {
  transition: ease-in 300ms;
  transform-style: preserve-3d;
}

.flip-leave-active {
  display: none;
}

.flip-enter,
.flip-leave {
  transform: rotateY(90deg);
  opacity: 0;
}
</style>
